<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Urlopy</span>
        <h3 class="page-title">
          <template v-if="isEdit">Szczegóły urlopu</template>
          <template v-else>Dodawanie urlopu</template>
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          v-if="!isPlanDate"
          theme="secondary"
          @click.prevent="$router.push('/urlopy')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          v-if="isPlanDate"
          theme="secondary"
          @click.prevent="$router.push('/plany-urlopowe')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          Wróć do listy
        </d-button>
        <d-button
          v-if="!isEdit"
          theme="success"
          @click.prevent="validateForm">
          Zapisz zmiany
        </d-button>
      </d-col>
    </d-row>
    <!-- Form -->
    <d-form>
      <d-card class="mb-5">
        <d-tabs card>
          <!-- Dane ogólne -->
          <d-tab :title="isEdit ? 'Twój urlop' : 'Zakres i typ urlopu'" active>
            <h4 class="mb-3 pb-3 border-bottom">
              {{ isEdit ? 'Twój urlop' : 'Zakres i typ urlopu'}}
            </h4>
            <div class="form-control" v-if="isEdit">
              <div class="form-group">
                <label style="font-weight: 600">
                  Status urlopu:
                </label>
                <d-badge outline :theme="data.status === 'NEW' ? 'info': (data.status === 'ACCEPTED' ? 'success' :
                (data.status === 'CANCELLED' ? 'warning' : 'danger'))" >
                  {{ data.status === 'ACCEPTED' ? 'Zaakceptowany' : (data.status === 'REJECTED' ? 'Odrzucony' :
                  (data.status === 'NEW' ? 'Oczekuje akceptacji' : 'Anulowany')) }}
                </d-badge>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Typ urlopu:
                </label>
                <p class="simpleText">
                  {{data.type_name}}
                </p>
              </div>
              <div class="form-group" v-if="data.plan_id !== null">
                <label style="font-weight: 600">
                  Zgodność z planem urlopowym:
                </label>
                <p class="simpleText">
                  {{ data.plan_id > 0 ? 'Tak' : (data.plan_id === 0 ? 'Nie' : '')  }}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Urlop od:
                </label>
                <p class="simpleText">
                  {{data.date_start}}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Urlop do:
                </label>
                <p class="simpleText">
                  {{data.date_end}}
                </p>
              </div>
              <div class="form-group">
                <label v-if="userData.employment_type !== 'E_FULL_TIME'" style="font-weight: 600">
                  Liczba godzin urlopu:
                </label>
                <label v-else style="font-weight: 600">
                  Dni urlopu:
                </label>
                <p class="simpleText" v-if="userData.employment_type === 'E_FULL_TIME'">
                  {{ data.hours ? (data.hours + ' dni') : 'brak'}}
                </p>
                <p class="simpleText" v-else>
                  {{ data.hours ? (data.hours + ' godzin') : 'brak'}}
                </p>
              </div>
              <div class="form-group" v-if="(userData.employment_type !== 'E_FULL_TIME') && (data.date_start.slice(0, 4) !== data.date_end.slice(0, 4))">
                <label style="font-weight: 600">
                  Liczba godzin w nowym roku
                </label>
                <p class="simpleText">
                  {{ data.hours_next_year ? (data.hours_next_year + ' godzin') : 'brak'}}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Do wykorzystania pozostało:
                </label>
                <p class="simpleText" v-if="userData.employment_type === 'E_FULL_TIME'">
                  {{ data.hours_available ? (data.hours_available + ' dni') : 'brak'}}
                </p>
                <p class="simpleText" v-if="userData.employment_type !== 'E_FULL_TIME'">
                  {{ data.hours_available ? (data.hours_available + ' godzin') : 'brak'}}
                </p>
              </div>
              <div class="form-group">
                <label style="font-weight: 600">
                  Uwagi:
                </label>
                <p class="simpleText">
                  {{data.user_description ? data.user_description : 'brak'}}
                </p>
              </div>
            </div>
            <div class="form-control mt-3" v-if="data.boss_description" :style="data.status === 'ACCEPTED' ? 'border-color: #17c671' : (data.status === 'REJECTED' ? 'border-color: #c4183c' : '')">
              <div class="form-group">
                <label style="font-weight: 600">
                  Uwagi przełożonego:
                </label>
                <p class="simpleText">
                  {{data.boss_description ? data.boss_description : 'brak'}}
                </p>
              </div>
            </div>
            <validation-observer ref="holidays-form" tag="form">
              <div class="form-group" v-if="!isEdit">
                <label style="font-weight: 100">
                  Do wykorzystania pozostało:
                </label>
                <h5 :style="userData.available_days === 0  ? 'color: #ad1535' : 'color: #14af64'">
                  {{userData.available_hours}} {{userData.employment_type === 'E_FULL_TIME' ? 'dni' : 'godzin'}}
                </h5>
              </div>
              <div class="form-group" v-if="!isEdit">
                <validation-provider
                  :rules="'required'"
                  name="date_start"
                  v-slot="{ errors }">
                  <label for="date_start">
                    Zakres urlopu:
                  </label>
                  <date-picker
                    :class="['reservation-style', 'mr-2', (importantDate === true && !data.date_start) ? 'invalid-date' : '']"
                    v-model="range"
                    validate
                    range
                    valueType="format"
                    style="width: 100%"/>
                </validation-provider>
                <div class="invalid-feedback" style="display: block;" v-if="importantDate === true && !data.date_start">
                  {{ errors[0] }}
                </div>
              </div>
              <div class="form-group" v-if="!isEdit">
                <validation-provider
                  :rules="'required'"
                  :name="'type_id'"
                  v-slot="{ errors }">
                  <div class="form-group" style="margin-bottom: 2.5rem;">
                    <label class="title-box" :for="data.type_id">
                      Typ urlopu:
                    </label>
                    <v-select
                      class="reservation-style reservation-style-select-max"
                      :disabled="isEdit"
                      :options="types"
                      v-model="data.type_id"
                      :reduce="type => type.id"
                      placeholder="Wybierz kategorię"
                      label="id">
                      <template #search="{attributes, events}">
                        <d-input
                          class="input-for-select"
                          :state="errors.length ? 'invalid' : null"
                          :required="!data.type_id"
                          v-bind="attributes"
                          v-on="events"
                        />
                      </template>
                      <template slot="option" slot-scope="option">
                        <div class="d-center">
                          {{ option.name }}
                        </div>
                      </template>
                      <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">
                          {{ option.name }}
                        </div>
                      </template>
                    </v-select>
                  </div>
                  <div class="invalid-feedback" style="display: block; margin-top: -1.4rem;">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group" v-if="false">
                <label for="vacation_hours">
                  Liczba godzin urlopu:
                </label>
                <validation-provider
                  name="vacation"
                  v-slot="{ errors }">
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.hours" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group" v-if="(userData.employment_type !== 'E_FULL_TIME') && (range.length ? (range[0].slice(0, 4) !== range[1].slice(0, 4)) : '') && !isEdit">
                <label for="vacation_hours">
                  Liczba godzin w nowym roku
                </label>
                <validation-provider
                  name="vacation"
                  v-slot="{ errors }">
                  <d-input
                    type="number"
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.hours_next_year" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group" v-if="!isEdit">
                <label for="user_description">
                  Uwagi:
                </label>
                <validation-provider
                  name="description"
                  v-slot="{ errors }">
                  <d-form-textarea
                    :state="errors.length ? 'invalid' : null"
                    v-model="data.user_description" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>
              <div class="form-group text-center"  v-if="isEdit && (data.status === 'NEW' || data.status === 'CANCELLED')">
                <d-button
                  :disabled="data.status === 'CANCELLED'"
                  theme="danger"
                  class="mt-4"
                  style="width: 20%"
                  @click.prevent="handleAccepted('CANCELLED')">
                  Anuluj urlop
                </d-button>
                <d-modal v-if="showAccepted" @close="handleClose('NEW')" style="background-color: rgba(0,0,0,0.6)!important;">
                  <d-modal-header>
                    <d-modal-title>Potwierdzasz anulowanie urlopu ?</d-modal-title>
                  </d-modal-header>
                  <d-modal-body>
                    <div class="popup-box-buttons">
                      <d-button
                        style="min-width: 40%;"
                        theme="success"
                        class="text-nowrap ml-2 mr-2"
                        @click.prevent="cancelForm">
                        Potwierdź
                      </d-button>
                      <d-button
                        style="min-width: 40%;"
                        theme="light"
                        class="text-nowrap ml-2"
                        @click.prevent="handleClose('NEW')">
                        Anuluj
                      </d-button>
                    </div>
                  </d-modal-body>
                </d-modal>
              </div>
            </validation-observer>
            <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center">
              Trwa ładowanie danych&hellip;
            </div>

            <d-alert
              v-if="loadError"
              show
              theme="warning">
              Wczytywanie danych nie powiodło się. <a href="javascript:window.location.reload();" class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
            </d-alert>
          </d-tab>
        </d-tabs>
      </d-card>
    </d-form>
  </d-container>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

const moment = require('moment');

export default {
  name: 'holidays-form',
  components: { DatePicker },
  computed: {
    userData () {
      return this.$store.getters.getAccount
    },
    allDataLoaded () {
      return this.loaded && this.loadedHolidays;
    },
    isEdit () {
      return !!this.$route.params.id;
    },
    isPlanDate () {
      return !!this.$route.params.date;
    },
  },
  data() {
    return {
      data: {
        status: 'NEW',
        type_id: '',
        days: null,
        type_name: '',
        hours_available: '',
        user_description: '',
        boss_description: '',
        date_start: '',
        date_end: '',
        plan_id: '',
        hours: null,
        hours_next_year: null
      },
      loaded: false,
      loadError: false,
      showAccepted: false,
      importantDate: false,
      holidays: [],
      range: [],
      types: [],
      loadedHolidays: false,
      moment
    };
  },
  mounted () {
    if (this.isEdit) {
      this.loadItemData();
    } else {
      this.loaded = true;
    }
    if (this.isPlanDate) {
      this.planDate();
    }
    this.loadAdditionalData();
    this.getHolidaysTypes();
    this.userAccountGet()
  },
  created () {
    setTimeout(() => {
      this.calendarDate();
    }, 1000);
  },
  watch: {
    'range': function (data) {
      this.data.date_start = data[0] ? data[0] : this.data.date_start;
      this.data.date_end = data[1] ? data[1] : this.data.date_end;
    }
  },
  methods: {
    userAccountGet () {
      this.$store.dispatch('userAccountGet')
    },
    handleClose(status) {
      this.showAccepted = false;
      this.data.status = status
    },
    handleAccepted(status) {
      this.showAccepted = !this.showAccepted;
      this.data.status = status
    },
    planDate() {
      this.data.date_start = this.$route.params.date.slice(0, 10);
      this.data.date_end = this.$route.params.date.slice(11, 21);
      this.data.plan_id = this.$route.params.date.slice(22);
    },
    calendarDate () {
      this.range = [(this.data.date_start), (this.data.date_end)];
    },
    getHolidaysTypes () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/holidays/types',
        outputKey: 'types',
      });
    },
    loadItemData () {
      FormUtils.loadItemData(this, {
        endpointBase: '/holidays/item/',
        instanceFields: ['type_id', 'type_name', 'date_start', 'date_end', 'status', 'hours_available', 'user_description', 'boss_description', 'plan_id', 'hours', 'hours_next_year'],
        loadedKey: 'loaded'
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/holidays/items',
        params: {
          pagination: false
        },
        outputKey: 'holidays',
        loadedKey: 'loadedHolidays',
        errorKey: 'loadError',
        successAction: () => {
          if (this.data.id) {
            this.holidays = this.holidays.filter(holiday => holiday.id === this.data.id);
          }
        }
      });
    },
    validateForm () {
      this.saveDaysAndHours = true;
      this.importantDate = true;
      FormUtils.validate(this.$refs['holidays-form'], this.submitForm);
    },
    submitForm () {
      let formDataToSend = this.prepareFormDataToSend();
      let endpointUrl = this.isEdit ? '/holidays/update/' + this.id : '/holidays/store';
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano urlop',
        successText: 'Urlop został dodany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja urlopu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/urlopy')
        }
      });
    },
    prepareFormDataToSend () {
      return {
        user_id: this.data.user_id,
        date_start: this.range[0] ? this.range[0] : this.data.date_start,
        date_end: this.range[1] ? this.range[1] : this.data.date_end,
        type_id: this.data.type_id,
        user_description: this.data.user_description,
        plan_id: this.data.plan_id,
        hours: this.data.hours,
        hours_next_year: this.data.hours_next_year,
        hours_available: this.data.hours_available
      };
    },
    cancelForm () {
      let formDataToSend = this.prepareCancelStatus();
      let endpointUrl = '/holidays/cancel/' + this.id;
      FormUtils.submit(this, {
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: 'Zapisano urlop',
        successText: 'Urlop został anulowany',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Modyfikacja urlopu nie powiodła się. Spróbuj ponownie.',
        successAction: () => {
          this.$router.push('/urlopy')
        }
      });
    },
    prepareCancelStatus () {
      return {
        status: this.data.status,
      };
    }
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/variables/mixins.scss';
  .popup-box-buttons {
    @include popupButtons
  }
  @import "../../assets/scss/layout/holidays-children.scss";
</style>
